import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import HomeSideNavBar, {explicitLogout} from "./HomeSideNavBar";
import Header from "./Header";
import ApiDataProvider from "./ApiDataContext";
import ProfilePage from "./UserManagement/ProfilePage";
import ChangePassword from "./UserManagement/ChangePassword";
import VehicleAlerts from "./UserManagement/VehicleAlerts";
import {BellRing, KeyRound, LogOut, Settings as SettingsIcon, UserCircle} from "lucide-react";
import PageHeader from "../components/layout/PageHeader";
import Tabs from "../components/ui/Tabs";
import Button from "../components/ui/Button";
import {getRole, hasPermission, ROLES} from "../utils/rolePermissions";

const PROFILE = "ProfilePage";
const CHANGE_PASSWORD = "ChangePassword";
const VEHICLE_ALERTS = "VehicleAlerts";

const TAB_META = {
  [PROFILE]:         {label: "Your details",   subtitle: "View and edit your personal information."},
  [CHANGE_PASSWORD]: {label: "Change password", subtitle: "Set a new password for your account."},
  [VEHICLE_ALERTS]:  {label: "Vehicle alerts",  subtitle: "Choose which GPS tracker alerts reach your phone and this browser."},
};

function Profile() {
  const [selectedComponent, setSelectedComponent] = useState(PROFILE);
  const activeMeta = TAB_META[selectedComponent] || {label: "Profile", subtitle: ""};
  const navigate = useNavigate();

  const tabItems = [
    {value: PROFILE,         label: "Your details",   icon: UserCircle},
    {value: CHANGE_PASSWORD, label: "Change password", icon: KeyRound},
    // Track Point drivers never receive vehicle alerts.
    getRole() !== ROLES.MOBI_TRACK && {value: VEHICLE_ALERTS, label: "Vehicle alerts", icon: BellRing},
  ].filter(Boolean);

  const renderSelectedComponent = () => {
    switch (selectedComponent) {
      case PROFILE:         return <ProfilePage />;
      case CHANGE_PASSWORD: return <ChangePassword />;
      case VEHICLE_ALERTS:  return <VehicleAlerts />;
      default:              return null;
    }
  };

  return (
    <ApiDataProvider>
      <div className="container">
        <div className="screen-layout">
          <Header />
          <HomeSideNavBar />
          <main className="flex-1 min-w-0 min-h-0 flex flex-col bg-surface-muted overflow-y-auto">
            <PageHeader
              title="Profile"
              subtitle={activeMeta.subtitle}
              breadcrumbs={[{label: "Profile"}, {label: activeMeta.label}]}
            />
            <Tabs value={selectedComponent} onChange={setSelectedComponent} items={tabItems} className="bg-white" />
            <div className="flex-1 min-h-0 px-2 sm:px-4 lg:px-6 py-4">
              {renderSelectedComponent()}
              <div className="sm:hidden mt-4 space-y-2">
                {hasPermission("sidebar_settings") && (
                  <Button variant="secondary" icon={SettingsIcon} className="w-full" onClick={() => navigate("/settings")}>
                    Settings
                  </Button>
                )}
                <Button variant="secondary" icon={LogOut} className="w-full" onClick={explicitLogout}>
                  Logout
                </Button>
              </div>
            </div>
          </main>
        </div>
      </div>
    </ApiDataProvider>
  );
}

export default Profile;
